import { Navbar, Nav, Container, NavDropdown, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { toast } from "react-toastify";
import {
  MdKeyboardDoubleArrowRight,
  MdKeyboardDoubleArrowLeft,
  MdList,
} from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  FaUser,
  FaRegListAlt,
  FaUsers,
  FaUsersSlash,
  FaMoneyBillAlt,
  FaUserPlus,
  FaClipboardList,
  FaChartLine,
  FaWhatsappSquare,
  FaPhoneAlt,
  FaWhatsapp,
  FaUserCircle,
  FaRegEdit,
  FaInfoCircle,
  FaChevronUp,
  FaChevronDown,
} from "react-icons/fa"; // Add the icons you need
import { FaClock } from "react-icons/fa6";
import {
  RiPassPendingFill,
  RiFolderUploadFill,
  RiQrCodeFill,
  RiBuilding4Fill,
  RiLogoutCircleRLine,
  RiBodyScanFill,
} from "react-icons/ri";
import { CgGym, CgProfile, CgMenuBoxed } from "react-icons/cg";
import { MdAccountBalance, MdQrCode2, MdManageAccounts } from "react-icons/md";
import { IoMdCloseCircleOutline } from "react-icons/io";

import logo from "../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { logout, setCredentials } from "../slices/authSlice";

import { getCurrentDate } from "../utils/getCurrentDate";
import { useEffect, useState } from "react";
import { useAdminLogoutMutation } from "../slices/AdminSilce";

const HeaderLeft = function ({ leftMenuOpen, setExpandMenu }) {
  const { userInfo } = useSelector((state) => state.auth);
  const domainUrl = window?.location?.origin;
  const selectedLanguage = userInfo?.preferredLanguage
    ? userInfo?.preferredLanguage
    : "English";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApi] = useAdminLogoutMutation();
  let gymId;
  if (userInfo) {
    gymId = userInfo.gymId?._id;
  }
  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
      dispatch(logout());
      // dispatch(removeUsers());
      navigate("/login");
      toast.success("Successfully logged out");
    } catch (err) {
      console.log(err);
    }
  };
  const [visitorsReminder, setVisitorsReminder] = useState(false);
  const [expiredUsersReminder, setExpiredUsersReminder] = useState(false);
  const [isUserManagementExpanded, setIsUserManagementExpanded] =
    useState(true);
  const [isExpanded, setIsExpanded] = useState(true);

  const goToSalesPage = (async) => {
    navigate("/sales");
  };
  const goToOnlineOrders = (async) => {
    navigate("/");
  };

  return (
    <header
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 1,
      }}
      className={`tealThemeHeaderTop`}
    >
      {userInfo ? (
        <>
          <Navbar
            style={{
              backgroundColor: "inherit", // Use any hex color code
              color: "#ffffff", // Set the text color
              height: "3rem",
              marginTop: "0.2px",
            }}
          >
            <Container
              style={{
                backgroundColor: "inherit", // Use any hex color code
                color: "#ffffff", // Set the text color
                height: "40px",
                marginTop: "0.2px",
              }}
            >
              <LinkContainer to="/">
                <Navbar.Brand>
                  {/* <img src={logo} alt="zpotter"></img>{" "} */}
                  {/* <label style={{ fontSize: "1.5rem" }}>ZPOTTER</label> */}
                  zpotter
                </Navbar.Brand>
              </LinkContainer>
              {new Date(getCurrentDate()) <= new Date("2025-02-22") && (
                <Nav.Link
                  style={{
                    color: "orange",
                    whiteSpace: "nowrap",
                    marginLeft: "7rem",
                    fontSize: "1.6rem",
                  }}
                  href="https://videos.zpotter.in/updateVideos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>Updated on 21-Feb-2025 : Click</strong>
                </Nav.Link>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <label style={{ fontSize: "1.5rem" }}>
                  {" "}
                  {userInfo ? userInfo?.gymId?.name : "zpotter"}
                </label>
              </div>
              {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav"> */}
              <Nav
                className="ms-auto"
                style={{
                  backgroundColor: "inherit",
                  color: "#ffffff",
                }}
              >
                {userInfo ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "10",
                        width: "100%",
                      }}
                    >
                      {/* <FaUserCircle style={{ marginRight: "3px" }} /> */}
                    </div>
                    <Button
                      onClick={goToOnlineOrders}
                      style={{ marginRight: "1.5rem" }}
                    >
                      Orders
                    </Button>{" "}
                    <Button
                      onClick={goToSalesPage}
                      style={{ marginRight: "1.5rem" }}
                    >
                      Sales
                    </Button>
                    <NavDropdown title={"Teju"} style={{ marginRight: "90px" }}>
                      <LinkContainer to="/companyDetails">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"Company Profile"}
                        </NavDropdown.Item>
                      </LinkContainer>
                      {/* <LinkContainer to="/">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"View Orders"}
                        </NavDropdown.Item>
                      </LinkContainer> */}
                      <LinkContainer to="/orderHistory">
                        <NavDropdown.Item>
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"Order History"}
                        </NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/allFoods">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"View FoodItems"}
                        </NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/viewMyOutlets">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"View Outlets"}
                        </NavDropdown.Item>
                      </LinkContainer>

                      {userInfo.role === "Super Admin" && (
                        <>
                          {/* <LinkContainer to="/createFoodItems">
                            <NavDropdown.Item>
                              {" "}
                              <CgProfile style={{ marginRight: "3px" }} />
                              {"Create FoodItems"}
                            </NavDropdown.Item>
                          </LinkContainer> */}
                          <LinkContainer to="/createOutlet">
                            <NavDropdown.Item>
                              {" "}
                              <CgProfile style={{ marginRight: "3px" }} />
                              {"Create Outlet"}
                            </NavDropdown.Item>
                          </LinkContainer>

                          {/* <LinkContainer to="/createAdmin">
                            <NavDropdown.Item>
                              <FaRegEdit style={{ marginRight: "3px" }} />
                              {"Create Admin"}
                            </NavDropdown.Item>
                          </LinkContainer> */}
                        </>
                      )}
                      <LinkContainer to="/allAdmins">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {"View Admins"}
                        </NavDropdown.Item>
                      </LinkContainer>

                      <LinkContainer to="/generateQR">
                        <NavDropdown.Item>
                          <MdQrCode2 style={{ marginRight: "2px" }} />
                          Generate QR Code
                        </NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/contactUs">
                        <NavDropdown.Item>
                          {" "}
                          <FaPhoneAlt style={{ marginRight: "2px" }} />
                          Contact Us
                        </NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Item onClick={handleLogout}>
                        <RiLogoutCircleRLine style={{ marginRight: "3px" }} />
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                ) : (
                  <LinkContainer to="/login">
                    <Nav.Link>
                      <FaUser />
                      Login
                    </Nav.Link>
                  </LinkContainer>
                )}
              </Nav>
              {/* </Navbar.Collapse> */}
            </Container>
          </Navbar>
        </>
      ) : (
        <></>
      )}
    </header>
  );
};

export default HeaderLeft;
